import { motion } from 'framer-motion';
import { MessageSquare, Zap, Copy } from 'lucide-react';

export function BlogCoverTemplates() {
  const bubbles = [
    { width: 'w-28', height: 'h-10', delay: 0, x: 10, y: 15 },
    { width: 'w-36', height: 'h-12', delay: 0.1, x: 55, y: 35 },
    { width: 'w-24', height: 'h-8', delay: 0.2, x: 20, y: 60 },
    { width: 'w-32', height: 'h-10', delay: 0.15, x: 60, y: 75 },
    { width: 'w-20', height: 'h-8', delay: 0.25, x: 75, y: 20 },
  ];

  return (
    <div className="w-full h-full bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 flex items-center justify-center overflow-hidden relative">
      {/* Background grid pattern */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(255,255,255,0.03) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.03) 1px, transparent 1px)',
          backgroundSize: '40px 40px'
        }} />
      </div>
      
      {/* Glowing effect */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 -translate-y-1/2 w-48 h-48 bg-primary/15 rounded-full blur-3xl" />
      <div className="absolute bottom-1/4 right-1/4 w-32 h-32 bg-blue-500/10 rounded-full blur-2xl" />
      
      {/* Bento Grid Layout */}
      <div className="relative z-10 w-full max-w-xs md:max-w-sm px-4">
        {/* Main grid container */}
        <div className="grid grid-cols-3 gap-2 md:gap-3">
          {/* Large template card */}
          <motion.div 
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            className="col-span-2 row-span-2 bg-slate-800/80 backdrop-blur-sm rounded-xl p-3 border border-slate-700/50 shadow-lg"
          >
            <div className="flex items-center gap-2 mb-2">
              <MessageSquare className="w-4 h-4 text-primary" />
              <span className="text-[10px] text-slate-400 font-medium">Réponse type</span>
            </div>
            <div className="space-y-1.5">
              <div className="h-2 w-full bg-slate-700 rounded" />
              <div className="h-2 w-5/6 bg-slate-700 rounded" />
              <div className="h-2 w-4/6 bg-slate-700 rounded" />
              <div className="h-2 w-3/4 bg-slate-700 rounded" />
            </div>
            <div className="mt-3 flex items-center justify-between">
              <div className="flex items-center gap-1 text-emerald-400">
                <Zap className="w-3 h-3" />
                <span className="text-[8px]">1-clic</span>
              </div>
              <Copy className="w-3 h-3 text-slate-500" />
            </div>
          </motion.div>
          
          {/* Small card 1 */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, delay: 0.1 }}
            className="bg-slate-800/60 backdrop-blur-sm rounded-lg p-2 border border-slate-700/50"
          >
            <div className="h-1.5 w-full bg-primary/40 rounded mb-1" />
            <div className="h-1.5 w-2/3 bg-slate-700 rounded" />
          </motion.div>
          
          {/* Small card 2 */}
          <motion.div 
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, delay: 0.2 }}
            className="bg-slate-800/60 backdrop-blur-sm rounded-lg p-2 border border-slate-700/50"
          >
            <div className="h-1.5 w-full bg-emerald-500/40 rounded mb-1" />
            <div className="h-1.5 w-1/2 bg-slate-700 rounded" />
          </motion.div>
          
          {/* Bottom row cards */}
          <motion.div 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.3 }}
            className="bg-gradient-to-br from-primary/20 to-primary/5 backdrop-blur-sm rounded-lg p-2 border border-primary/30"
          >
            <div className="h-1.5 w-full bg-primary/50 rounded mb-1" />
            <div className="h-1.5 w-3/4 bg-primary/30 rounded" />
          </motion.div>
          
          <motion.div 
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.3, delay: 0.35 }}
            className="col-span-2 bg-slate-800/60 backdrop-blur-sm rounded-lg p-2 border border-slate-700/50 flex items-center gap-2"
          >
            <div className="flex-1 space-y-1">
              <div className="h-1.5 w-full bg-slate-700 rounded" />
              <div className="h-1.5 w-2/3 bg-slate-700 rounded" />
            </div>
            <div className="w-6 h-6 bg-primary/20 rounded-full flex items-center justify-center">
              <Copy className="w-3 h-3 text-primary" />
            </div>
          </motion.div>
        </div>
      </div>
      
      {/* Decorative dots */}
      <div className="absolute top-6 left-6 w-2 h-2 bg-primary rounded-full animate-pulse" />
      <div className="absolute bottom-8 right-8 w-1.5 h-1.5 bg-emerald-400 rounded-full animate-pulse delay-300" />
      <div className="absolute top-1/4 right-12 w-1 h-1 bg-blue-400 rounded-full animate-pulse delay-500" />
    </div>
  );
}
